import axios from 'axios';

class SendLogClass {
  send(type, data) {
    try {
      const params = {
        type,
        data,
      };

      this._sendRequest(params);
    } catch (error) {
      console.error(error);
    }
  }

  sendAnalytic(data) {
    this.send('analytic', data);
  }

  async _sendRequest(data) {
    const URL = 'https://planoplan.com/a4474f73-c9cf-2b63-0eb2-60df2abbc035/interface-logs';

    try {
      return axios.post(URL, data);
    } catch (error) {
      console.error(error);
    }
  }
}
export const SendLog = new SendLogClass();
